var React = require('react');

function IconCaretRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1"},React.createElement("g",{"stroke":"#142B6F","strokeWidth":"2"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",{"transform":"translate(-272.000000, -1724.000000) translate(135.000000, 1603.000000) translate(0.000000, 118.000000) translate(138.000000, 4.000000)"},React.createElement("polyline",{"points":"0 0 8 8 0 16"})))))));
}

IconCaretRight.defaultProps = {"width":"11","height":"18","version":"1.1","viewBox":"0 0 11 18"};

module.exports = IconCaretRight;

IconCaretRight.default = IconCaretRight;
